<div [formGroup]="group" class="controls-alignment">
  <div style="display: grid;">
    <label class="radio-label-padding">{{field.labelName}} @if (isRequired) {
      <span>*</span>
    }</label>
    @if (field.description) {
      <p class="description" [innerHTML]="field.description"></p>
    }
  </div>
  <mat-radio-group [formControlName]="field.labelCode" class="displayGrid" [required]="isRequired">
    @for (item of sortedOptions; track item) {
      <mat-radio-button (change)="radioChange(item)" [value]="item.code">{{item.value}}
      </mat-radio-button>
    }
    @if (group.get(field.labelCode).hasError('required')) {
      <mat-error class="radio-buttonError">Value is mandatory</mat-error>
    }
  </mat-radio-group>
</div>

